import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { User } from 'api/notifications';
import { TeamsBulkUpdateStatus } from 'api/teams';
import { getUserById } from 'utils/idb-utils';

const Title = styled.div`
  font-size: var(--heading-5-size);
  font-weight: var(--heading-5-weight);
`;

const Description = styled.div`
  font-size: var(--font-size-base);
  font-weight: var(--heading-5-weight);
  color: var(--gray-70);
  margin: var(--spacing-03) 0;
`;

const Wrapper = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  max-width: 70%;
  min-height: 100px;
`;

type InProgress = {
  updateStatuses?: TeamsBulkUpdateStatus[];
};

const InProgress = (props: InProgress) => {
  const { updateStatuses } = props;

  const [initiatedUser, setInitiatedUser] = useState<User | null>(null);

  const fetchUser = useCallback(async () => {
    if (!updateStatuses || !updateStatuses[0]?.createdBy) {
      return;
    }

    const user = (await getUserById(updateStatuses[0]?.createdBy)) as User;

    setInitiatedUser(user);
  }, [updateStatuses]);

  useEffect(() => {
    fetchUser();
  }, [updateStatuses, fetchUser]);

  return (
    <Wrapper>
      {initiatedUser ? (
        <>
          <Title>
            <FormattedMessage id="projects.placeholders.update.inprogress.title" />
          </Title>
          <Description>
            <FormattedMessage id="projects.placeholders.update.inprogress.description" />
          </Description>
        </>
      ) : (
        <></>
      )}
    </Wrapper>
  );
};

export { InProgress };
